/* ==========================================================================
   Aftershoot opt-in  —  assets/aftershoot-optin.js   (v3)
   Replaces v2 entirely.

   v3 is self-contained: it loads and initialises PostHog itself if the page
   hasn't already done so. The existing inline snippet lives in a page
   template, not theme.liquid, so window.posthog was undefined on product
   pages and every toggle event was being silently dropped.

   Safe to run alongside that inline snippet — the guards below make sure
   init() happens exactly once per page whichever script gets there first.

   Config: TRIAL_VARIANT_ID adds a $0.00 line item so the trial is visible at
   checkout and in the confirmation email. The cart attribute
   `aftershoot_trial_optin` stays the source of truth for Flow.
   ========================================================================== */

(function () {
  'use strict';

  // ---- CONFIG -------------------------------------------------------------
  var TRIAL_VARIANT_ID = 42550899671122; // "Aftershoot — 30-day free trial"
  var POSTHOG_KEY = 'phc_umXjTMa7ctha1wg4qpqLXYoNJotqCovfXOYvssvkDUL';
  var POSTHOG_HOST = 'https://us.i.posthog.com';
  // -------------------------------------------------------------------------

  var ATTRIBUTE_KEY = 'aftershoot_trial_optin';
  var INPUT_SELECTOR = '[data-aftershoot-optin-input]';
  var WRAPPER_SELECTOR = '[data-aftershoot-optin]';
  var TOGGLE_EVENT = 'cart_aftershoot_trial_optin_toggled';

  var suppressSync = false;

  /* ------------------------------------------------------------- PostHog */

  var pendingEvents = [];
  var waiting = false;

  function posthogReady() {
    return !!(window.posthog && window.posthog.__loaded &&
              typeof window.posthog.capture === 'function');
  }

  function initPostHog() {
    if (window.__mastinPosthogInit) return;
    if (!window.posthog || typeof window.posthog.init !== 'function') return;
    if (window.posthog.__loaded) {           // another script already did it
      window.__mastinPosthogInit = true;
      return;
    }
    window.__mastinPosthogInit = true;
    window.posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      person_profiles: 'identified_only'
    });
  }

  // Load array.js ourselves unless the page's own snippet is already doing it.
  function ensurePostHog() {
    if (posthogReady()) { window.__mastinPosthogInit = true; return; }

    // The inline snippet leaves a stub with _i queued — it will load on its own.
    if (window.posthog && window.posthog._i) return;
    if (document.getElementById('mastin-posthog-loader')) return;

    var script = document.createElement('script');
    script.id = 'mastin-posthog-loader';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = POSTHOG_HOST + '/static/array.js';
    script.onload = initPostHog;
    script.onerror = function () {
      if (window.console && console.warn) {
        console.warn('[aftershoot-optin] PostHog failed to load');
      }
    };
    (document.head || document.documentElement).appendChild(script);
  }

  function flushPending() {
    pendingEvents.splice(0).forEach(function (entry) {
      try {
        window.posthog.capture(entry[0], entry[1]);
      } catch (e) {
        /* analytics must never break the cart */
      }
    });
  }

  function waitForPostHog() {
    if (waiting) return;
    waiting = true;

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;

      // array.js may have landed without anyone calling init yet.
      if (window.posthog && !window.posthog.__loaded) initPostHog();

      if (posthogReady()) {
        clearInterval(timer);
        waiting = false;
        flushPending();
        return;
      }

      if (tries > 40) { // ~10s
        clearInterval(timer);
        waiting = false;
        pendingEvents.length = 0;
        if (window.console && console.warn) {
          console.warn('[aftershoot-optin] PostHog never initialised — events dropped');
        }
      }
    }, 250);
  }

  function capture(eventName, properties) {
    if (posthogReady()) {
      try {
        window.posthog.capture(eventName, properties);
      } catch (e) {
        /* analytics must never break the cart */
      }
      return;
    }
    pendingEvents.push([eventName, properties]);
    ensurePostHog();
    waitForPostHog();
  }

  ensurePostHog();

  /* ---------------------------------------------------------------- utils */

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (response.ok) return response.json();

      // Surface Shopify's actual complaint, not just the status code.
      return response.json()
        .catch(function () { return {}; })
        .then(function (payload) {
          throw new Error(
            url + ' ' + response.status + ' — ' +
            (payload.description || payload.message || 'no detail')
          );
        });
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function allInputs() {
    return Array.prototype.slice.call(document.querySelectorAll(INPUT_SELECTOR));
  }

  function syncOthers(checked, sourceInput) {
    allInputs().forEach(function (input) {
      if (input !== sourceInput) input.checked = checked;
    });
  }

  function setSaving(wrapper, saving) {
    if (wrapper) wrapper.classList.toggle('is-saving', !!saving);
  }

  function showError(wrapper) {
    if (!wrapper || wrapper.querySelector('.aftershoot-optin__error')) return;
    var el = document.createElement('span');
    el.className = 'aftershoot-optin__error';
    el.textContent = "Couldn't save that just now — try again, or start your trial after checkout.";
    wrapper.appendChild(el);
  }

  function clearError(wrapper) {
    if (!wrapper) return;
    var el = wrapper.querySelector('.aftershoot-optin__error');
    if (el) el.parentNode.removeChild(el);
  }

  function findTrialLine(cart) {
    if (!TRIAL_VARIANT_ID) return null;
    return (cart.items || []).filter(function (item) {
      return item.variant_id === TRIAL_VARIANT_ID;
    })[0] || null;
  }

  /* ------------------------------------------------------------ cart write */

  function writeAttribute(checked) {
    var attributes = {};
    attributes[ATTRIBUTE_KEY] = checked ? 'true' : 'false';
    return postJSON('/cart/update.js', { attributes: attributes });
  }

  function syncTrialLine(checked) {
    if (!TRIAL_VARIANT_ID) return Promise.resolve();

    return getCart().then(function (cart) {
      var line = findTrialLine(cart);

      if (checked && !line) {
        return postJSON('/cart/add.js', {
          items: [{ id: TRIAL_VARIANT_ID, quantity: 1 }]
        });
      }
      if (!checked && line) {
        return postJSON('/cart/change.js', { id: line.key, quantity: 0 });
      }
      return null;
    });
  }

  function refreshCartUI() {
    if (document.querySelector('[data-aftershoot-optin][data-surface="cart"]')) {
      window.location.reload();
      return;
    }
    if (window.theme && typeof window.theme.CartDrawer === 'function') {
      try {
        suppressSync = true;
        new window.theme.CartDrawer();
        setTimeout(function () { suppressSync = false; }, 1000);
      } catch (e) {
        suppressSync = false;
      }
    }
  }

  /* ------------------------------------------------------------- handlers */

  function onToggle(input) {
    var wrapper = input.closest(WRAPPER_SELECTOR);
    var surface = wrapper ? wrapper.getAttribute('data-surface') : 'unknown';
    var checked = input.checked;

    clearError(wrapper);
    setSaving(wrapper, true);
    syncOthers(checked, input);

    syncTrialLine(checked)
      .then(function () {
        return writeAttribute(checked);
      })
      .then(function (cart) {
        capture(TOGGLE_EVENT, {
          checked: checked,
          surface: surface,
          line_item_mode: !!TRIAL_VARIANT_ID,
          cart_token: cart.token,
          cart_value: cart.total_price / 100,
          cart_currency: cart.currency,
          cart_item_count: cart.item_count,
          cart_skus: (cart.items || [])
            .map(function (item) { return item.sku; })
            .filter(Boolean),
          product_handle: wrapper ? wrapper.getAttribute('data-product-handle') : null
        });

        if (TRIAL_VARIANT_ID) refreshCartUI();
      })
      .catch(function (error) {
        input.checked = !checked;
        syncOthers(!checked, input);
        showError(wrapper);
        if (window.console && console.warn) {
          console.warn('[aftershoot-optin] failed to persist opt-in', error);
        }
      })
      .then(function () {
        setSaving(wrapper, false);
      });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.matches !== 'function') return;
    if (!target.matches(INPUT_SELECTOR)) return;
    onToggle(target);
  });

  /* ------------------------------------------------ keep states in agreement */

  if (window.jQuery) {
    // Deleting the $0 line from the drawer is an opt-out. Without this the
    // attribute would still say true and Flow would fire anyway.
    window.jQuery('body').on('updateCart.ajaxcart', function (evt, cart) {
      if (!TRIAL_VARIANT_ID || suppressSync || !cart) return;

      var hasLine = !!findTrialLine(cart);
      var attributeSaysYes =
        cart.attributes && cart.attributes[ATTRIBUTE_KEY] === 'true';

      if (attributeSaysYes && !hasLine) {
        writeAttribute(false).then(function () {
          syncOthers(false, null);
          capture(TOGGLE_EVENT, {
            checked: false,
            surface: 'drawer_line_removed',
            line_item_mode: true,
            cart_token: cart.token
          });
        });
      }
    });

    window.jQuery('body').on('added.ajaxProduct', function () {
      var wrapper = document.querySelector('[data-aftershoot-optin][data-surface="pdp"]');
      var input = wrapper ? wrapper.querySelector(INPUT_SELECTOR) : null;
      capture('cart_add_with_aftershoot_optin', {
        checked: !!(input && input.checked),
        product_handle: wrapper ? wrapper.getAttribute('data-product-handle') : null
      });
    });
  }
})();
